import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL?.trim();
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();

// createClient throws if url/key are empty — without this, the whole app stays blank locally.
const fallbackUrl = "http://127.0.0.1:54321";
const fallbackKey = "local-dev-placeholder-not-configured";

if (!url || !anonKey) {
  console.warn(
    "VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY missing — copy .env.example to .env.local. Using placeholders; data/API calls will not work until configured."
  );
}

export const supabase = createClient(url || fallbackUrl, anonKey || fallbackKey);
